module.exports = __webpack_public_path__ + "static/media/walking.82a8b6bb.svg";